import { FileExcelOutlined, PrinterOutlined, RedoOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, DatePickerProps, Flex, Form, Image, Modal, Row, Select, Switch, Tooltip } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { Filtro } from "../../../components/filtroComponent/filtro";
import FiltroComponent from "../../../components/filtroComponent/filtroComponent";
import { EmpresaModel } from "../../../models/empresa/empresaModel";
import { BuscarRelatorioLancamentoFinanceiroModel } from "../../../models/relatorio/buscarRelatorioLancamentoFinanceiroModel";
import { RelatorioLancamentoFinanceiroModel } from "../../../models/relatorio/relatorioLancamentoFinanceiroModel";
import { RelatorioLancamentoFinanceiroPorMesModel } from "../../../models/relatorio/relatorioLancamentoFinanceiroPorMesModel";
import { setTitle } from "../../../redux/slices/configuracoes/configuracoesSlice";
import { setBuscaRelatorioLancamentoFinanceiro, setModalRelatorioLancamentoFinanceiro } from "../../../redux/slices/relatorio/relatorioSlice";
import { buscarEmpresa } from "../../../services/empresaService";
import { buscarRelatorioLancamentoFinanceiro, buscarRelatorioLancamentoFinanceiroPorMes } from "../../../services/relatorioService";
import { currencyBRL } from "../../../util/dinheiroBRAuxiliar";
import { newFormatPorcentagem } from "../../../util/formats";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import RelatorioLancamentoComparativo from "./components/comparativo";
import { RelatorioComparativoHtml } from "./components/comparativo/components/relatorioHtml";
import { pivotData } from "./components/comparativo/functions/pivotData";
import { sortAnoMes } from "./components/comparativo/functions/sortAnoMes";
import RelatorioLancamentoPlanoConta from "./components/planoConta";
import { RelatorioPlanoContaHtml } from "./components/planoConta/components/relatorioHtml";
import RelatorioLancamentoTransferencia from "./components/transferencia";
import { RelatorioTransferenciaHtml } from "./components/transferencia/components/relatorioHtml";
import ModalDetalheRelatorioLancamentos from "./modals/detalhe";

dayjs.locale("pt-br");

const relatorios: any = {
  planoConta: RelatorioLancamentoPlanoConta,
  comparativo: RelatorioLancamentoComparativo,
  transferencia: RelatorioLancamentoTransferencia,
};

const LancamentosRelatorio = () => {
  //estados globais
  const empresaState = useAppSelector((state) => state.empresa);
  const relatorioState = useAppSelector((state) => state.relatorio);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [openFiltros, setOpenFiltros] = useState<boolean>(false);
  const [idEmpresaAtual, setIdEmpresaAtual] = useState<number | null>(null);

  const relatorioImpressaoPlanoConta = useRef<HTMLDivElement>(null);
  const relatorioImpressaoComparativo = useRef<HTMLDivElement>(null);
  const relatorioImpressaoTransferencia = useRef<HTMLDivElement>(null);

  const Relatorio = relatorios[relatorioState.buscaLancamentoFinanceiro.tipoRelatorio];

  useEffect(() => {
    dispatch(setTitle("RELATÓRIO DE LANÇAMENTOS"));
    dispatch(buscarEmpresa(empresaState.busca));
    form.setFieldsValue({
      tipoRelatorio: relatorioState.buscaLancamentoFinanceiro.tipoRelatorio,
      tipoDataFiltro: relatorioState.buscaLancamentoFinanceiro.tipoDataFiltro,
      dataInicio: dayjs(relatorioState.buscaLancamentoFinanceiro.dataInicio).startOf("day"),
      dataFim: dayjs(relatorioState.buscaLancamentoFinanceiro.dataFim).startOf("day"),
      exibirTransferencias: relatorioState.buscaLancamentoFinanceiro.exibirTransferencias,
    });

    if (persistedState.user.empresa !== null) {
      let idEmpresa = parseInt(persistedState.user.empresa.idEmpresa.toString());
      form.setFieldsValue({ idEmpresa: idEmpresa });
      setIdEmpresaAtual(idEmpresa);
      var busca: BuscarRelatorioLancamentoFinanceiroModel = { ...relatorioState.buscaLancamentoFinanceiro, idEmpresa: idEmpresa };
      dispatch(setBuscaRelatorioLancamentoFinanceiro(busca));
      dispatch(buscarRelatorioLancamentoFinanceiro(busca));
    }
  }, []);

  const onChangeEmpresa = (value: number) => {
    setIdEmpresaAtual(value);

    let busca: BuscarRelatorioLancamentoFinanceiroModel = { ...relatorioState.buscaLancamentoFinanceiro, idEmpresa: value };

    dispatch(setBuscaRelatorioLancamentoFinanceiro(busca));
    buscar(busca);
  };

  const onChangeTipo = (value: string) => {
    let busca: BuscarRelatorioLancamentoFinanceiroModel = { ...relatorioState.buscaLancamentoFinanceiro, tipoRelatorio: value };

    dispatch(setBuscaRelatorioLancamentoFinanceiro(busca));
    buscar(busca);
  };

  const onChangeDateInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarRelatorioLancamentoFinanceiroModel = { ...relatorioState.buscaLancamentoFinanceiro, dataInicio: dayjs(value).startOf("day").toDate() };

    dispatch(setBuscaRelatorioLancamentoFinanceiro(busca));
    buscar(busca);
  };

  const onChangeDateFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarRelatorioLancamentoFinanceiroModel = { ...relatorioState.buscaLancamentoFinanceiro, dataFim: dayjs(value).startOf("day").toDate() };

    dispatch(setBuscaRelatorioLancamentoFinanceiro(busca));
    buscar(busca);
  };

  const onChangeTipoData = (value: string) => {
    let busca: BuscarRelatorioLancamentoFinanceiroModel = { ...relatorioState.buscaLancamentoFinanceiro, tipoDataFiltro: value };

    dispatch(setBuscaRelatorioLancamentoFinanceiro(busca));
    buscar(busca);
  };

  const onChangeTransferencia = (value: boolean) => {
    let busca: BuscarRelatorioLancamentoFinanceiroModel = { ...relatorioState.buscaLancamentoFinanceiro, exibirTransferencias: value };

    dispatch(setBuscaRelatorioLancamentoFinanceiro(busca));
    buscar(busca);
  };

  //componente de filtro
  const onChangeMostrarFiltros = async () => {
    try {
      await form.validateFields();
      setOpenFiltros(!openFiltros);
    } catch (e) {}
  };

  const buscar = async (busca: BuscarRelatorioLancamentoFinanceiroModel | null) => {
    try {
      await form.validateFields();
      if ((busca !== null && busca.tipoRelatorio === "planoConta") || (busca === null && relatorioState.buscaLancamentoFinanceiro.tipoRelatorio === "planoConta")) {
        dispatch(buscarRelatorioLancamentoFinanceiro(busca !== null ? busca : relatorioState.buscaLancamentoFinanceiro));
      }
      if ((busca !== null && busca.tipoRelatorio === "comparativo") || (busca === null && relatorioState.buscaLancamentoFinanceiro.tipoRelatorio === "comparativo")) {
        dispatch(buscarRelatorioLancamentoFinanceiroPorMes(busca !== null ? busca : relatorioState.buscaLancamentoFinanceiro));
      }
      if ((busca !== null && busca.tipoRelatorio === "transferencia") || (busca === null && relatorioState.buscaLancamentoFinanceiro.tipoRelatorio === "transferencia")) {
        dispatch(buscarRelatorioLancamentoFinanceiro(busca !== null ? { ...busca, somenteTransferencias: true } : { ...relatorioState.buscaLancamentoFinanceiro, somenteTransferencias: true }));
      }
    } catch (e) {}
  };

  const onPrint = useReactToPrint({
    content: () =>
      relatorioState.buscaLancamentoFinanceiro.tipoRelatorio === "planoConta"
        ? relatorioImpressaoPlanoConta.current
        : relatorioState.buscaLancamentoFinanceiro.tipoRelatorio === "comparativo"
        ? relatorioImpressaoComparativo.current
        : relatorioImpressaoTransferencia.current,
  });

  const handleExcel = () => {
    var data: any = [];

    if (relatorioState.buscaLancamentoFinanceiro.tipoRelatorio === "planoConta") {
      data.push({
        "Filtro Empresa": empresaState.list.find((a: EmpresaModel) => a.id === relatorioState.buscaLancamentoFinanceiro.idEmpresa)?.apelido,
      });

      data.push({
        "Filtro Empresa": "Data Inicial",
      });
      data.push({
        "Filtro Empresa": dayjs(relatorioState.buscaLancamentoFinanceiro.dataInicio).format("DD/MM/YYYY"),
      });

      data.push({
        "Filtro Empresa": "Data Final",
      });
      data.push({
        "Filtro Empresa": dayjs(relatorioState.buscaLancamentoFinanceiro.dataFim).format("DD/MM/YYYY"),
      });

      data.push({
        "Filtro Empresa": "Descrição",
        "": "Valor",
        " ": "Percentual",
        "  ": "Percentual do Rendimento",
      });

      relatorioState.listLancamentoFinanceiro.forEach((item: RelatorioLancamentoFinanceiroModel) => {
        data.push({
          "Filtro Empresa": `${item.codigo} ${item.denominacao}`,
          "": item.valor !== null ? currencyBRL(item.valor) : item.valor,
          " ": item.percentual !== null ? newFormatPorcentagem(item.percentual, 4) : item.percentual,
          "  ": item.percentualReceita !== null ? newFormatPorcentagem(item.percentualReceita, 4) : item.percentualReceita,
        });
      });
    }

    if (relatorioState.buscaLancamentoFinanceiro.tipoRelatorio === "comparativo") {
      const pivotedData = pivotData(relatorioState.listLancamentoFinanceiroPorMes);

      const uniqueAnoMes = Array.from(new Set(relatorioState.listLancamentoFinanceiroPorMes.map((item: RelatorioLancamentoFinanceiroPorMesModel) => item.anoMes)));
      const sortedAnoMes = sortAnoMes(uniqueAnoMes);

      const resolveValor = (cell: any): number => {
        if (cell && typeof cell === "object" && "valor" in cell) {
          const { valor } = cell as { valor: number | null | undefined };
          return valor ?? 0;
        }
        const numeric = Number(cell);
        return Number.isFinite(numeric) ? numeric : 0;
      };

      data.push({
        "Filtro Empresa": empresaState.list.find((a: EmpresaModel) => a.id === relatorioState.buscaLancamentoFinanceiro.idEmpresa)?.apelido,
      });
      data.push({ "Filtro Empresa": "Data Inicial" });
      data.push({ "Filtro Empresa": dayjs(relatorioState.buscaLancamentoFinanceiro.dataInicio).format("DD/MM/YYYY") });
      data.push({ "Filtro Empresa": "Data Final" });
      data.push({ "Filtro Empresa": dayjs(relatorioState.buscaLancamentoFinanceiro.dataFim).format("DD/MM/YYYY") });
      data.push({ "Filtro Empresa": "" });

      const headers: any = { "Filtro Empresa": "Descrição", "": "", " ": "" };
      sortedAnoMes.forEach((anoMes) => {
        headers[anoMes] = anoMes.toUpperCase();
      });
      headers["Média"] = "Média";
      data.push(headers);

      pivotedData.forEach((item) => {
        const row: any = {
          "Filtro Empresa": `${item.codigo} ${item.denominacao}`,
          "": "",
          " ": "",
        };
        const values: number[] = [];
        sortedAnoMes.forEach((anoMes) => {
          const valor = resolveValor(item[anoMes]);
          row[anoMes] = currencyBRL(valor);
          values.push(valor);
        });
        const filteredValues = values.filter((val) => val !== undefined && val !== null);
        const total = filteredValues.reduce((sum, val) => sum + val, 0);
        const average = filteredValues.length > 0 ? total / filteredValues.length : 0;
        row["Média"] = currencyBRL(average);
        data.push(row);
      });
    }

    if (relatorioState.buscaLancamentoFinanceiro.tipoRelatorio === "transferencia") {
      data.push({
        "Filtro Empresa": empresaState.list.find((a: EmpresaModel) => a.id === relatorioState.buscaLancamentoFinanceiro.idEmpresa)?.apelido,
      });

      data.push({
        "Filtro Empresa": "Data Inicial",
      });
      data.push({
        "Filtro Empresa": dayjs(relatorioState.buscaLancamentoFinanceiro.dataInicio).format("DD/MM/YYYY"),
      });

      data.push({
        "Filtro Empresa": "Data Final",
      });
      data.push({
        "Filtro Empresa": dayjs(relatorioState.buscaLancamentoFinanceiro.dataFim).format("DD/MM/YYYY"),
      });

      data.push({
        "Filtro Empresa": "Descrição",
        "": "Valor",
      });

      relatorioState.listLancamentoFinanceiro.forEach((item: RelatorioLancamentoFinanceiroModel) => {
        data.push({
          "Filtro Empresa": `${item.codigo} ${item.denominacao}`,
          "": item.valor !== null ? currencyBRL(item.valor) : item.valor,
        });
      });
    }

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "RelatórioLançamentos.xlsx");
  };

  return (
    <Flex vertical>
      <Filtro abrir={openFiltros} funcao={onChangeMostrarFiltros} />
      {openFiltros && <FiltroComponent idEmpresa={idEmpresaAtual} origem={"relatorioLancamentoPlanoConta"} />}
      <Form layout="vertical" form={form} style={openFiltros ? { marginTop: "0px" } : { marginTop: "14px" }}>
        <Row gutter={12} align="bottom">
          <Col span={22}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresa"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Tipo relatório" name="tipoRelatorio">
                <Select
                  onChange={onChangeTipo}
                  style={{ width: 150 }}
                  options={[
                    {
                      value: "planoConta",
                      label: "Plano de Conta",
                    },
                    {
                      value: "comparativo",
                      label: "Comparativo",
                    },
                    {
                      value: "transferencia",
                      label: "Transferência",
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item label="Tipo de data" name="tipoDataFiltro">
                <Select
                  onChange={onChangeTipoData}
                  style={{ width: 150 }}
                  options={[
                    { label: "Sorteio", value: "SORT" },
                    { label: "Lançamento", value: "LANC" },
                  ]}
                />
              </Form.Item>
              <Form.Item label="Data início" name="dataInicio">
                <DatePicker placeholder="" onChange={onChangeDateInicio} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data fim" name="dataFim">
                <DatePicker placeholder="" onChange={onChangeDateFim} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              {relatorioState.buscaLancamentoFinanceiro.tipoRelatorio !== "transferencia" && (
                <Form.Item label="Exibir transferências" name="exibirTransferencias">
                  <Switch size="small" onChange={onChangeTransferencia} checked={form.getFieldValue("exibirTransferencias")} />
                </Form.Item>
              )}
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<RedoOutlined />} type="primary" onClick={() => buscar(null)} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={2}>
            <Flex justify="end" gap={8}>
              <Form.Item name="botaoCarregar" label=" ">
                <Button icon={<PrinterOutlined />} onClick={onPrint} />
              </Form.Item>
              <Form.Item name="botaoCarregar" label=" ">
                <Button icon={<FileExcelOutlined />} onClick={handleExcel}></Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      <Modal
        title={"DETALHES LANÇAMENTOS"}
        centered
        width={1200}
        open={relatorioState.modalLancamentoFinanceiro}
        onCancel={() => dispatch(setModalRelatorioLancamentoFinanceiro(false))}
        footer={null}
        destroyOnHidden
      >
        <ModalDetalheRelatorioLancamentos />
      </Modal>
      <Relatorio key={relatorioState.buscaLancamentoFinanceiro.tipoRelatorio} />
      <div style={{ display: "none" }}>
        <RelatorioPlanoContaHtml ref={relatorioImpressaoPlanoConta} />
      </div>
      <div style={{ display: "none" }}>
        <RelatorioComparativoHtml ref={relatorioImpressaoComparativo} />
      </div>
      <div style={{ display: "none" }}>
        <RelatorioTransferenciaHtml ref={relatorioImpressaoTransferencia} />
      </div>
    </Flex>
  );
};

export default LancamentosRelatorio;
